import React from 'react'
import PropTypes from 'prop-types'

import * as cookie from '$utils/cookie'
import { dataUTMPageContextShape } from '$utils/prop-types'

import ProjectsListItem from './ProjectsListItem'
import ProjectsListPlaceholderItem from './ProjectsListPlaceholderItem'
import { ModalProjectRemindMe, ModalProjectNoAuth } from '../Project/Modals'

const COOKIE_MODAL_NAMESPACE = 'ul_modal_remind_me'

class ProjectsList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      modalShowedUp: false
    }
  }

  handleCloseModal = () => {
    this.setState({
      isOpen: false
    })
  }

  handleModal = (project, status) => {
    // we don't want to show modal for unlike event
    if (status && status === 'neutral') return

    const { isAuthenticated } = this.props
    const hasCookie = cookie.get(COOKIE_MODAL_NAMESPACE) === 'true'
    if (hasCookie) {
      this.setState({
        modalShowedUp: true
      })
    }

    // do not display modal if project ended
    // also shutdown the modal if cookie is here and
    // user is authenticated
    if ((isAuthenticated && hasCookie) || project.finished) {
      this.setState({
        isOpen: false
      })
      return
    }

    this.setState(
      {
        isOpen: this.state.isOpen ? false : true
      },
      () => {
        cookie.set(COOKIE_MODAL_NAMESPACE, true, { expires: +new Date(), path: '/', domain: 'ulule.com' })
      }
    )
  }

  onError = () => {
    const { isAuthenticated } = this.props

    if (!isAuthenticated) {
      this.setState({
        isOpen: true
      })
    }

    return
  }

  render() {
    const {
      dataUTMPageContext,
      nbPlaceholders,
      noCss,
      currentLanguage,
      currentCurrency,
      rates,
      isAuthenticated,
      urls,
      modalImg,
      projects,
      isLikeCompact
    } = this.props

    let list
    if (nbPlaceholders) {
      if (nbPlaceholders < 0) {
        list = projects && new Array(-nbPlaceholders).fill(null).concat(projects)
      } else {
        list = projects && projects.concat(new Array(nbPlaceholders).fill(null))
      }
    } else {
      list = projects
    }

    const defaultClasses = 'b-list b-list--inline'

    return (
      <ul className={`b-blink__projects ${noCss ? '' : defaultClasses}`}>
        {list &&
          list.length > 0 &&
          list.map((project, index) => {
            return (
              <li
                className={`b-list__item ${!project && 'placeholder'}`}
                key={`project-${index}`}
                data-project-id={project ? project.id : undefined}
                data-selected-project={project && project.is_featured ? 'true' : undefined}
                data-page-identifier={dataUTMPageContext && dataUTMPageContext.value}
                data-page-type={dataUTMPageContext && dataUTMPageContext.type}
              >
                {project ? (
                  <ProjectsListItem
                    rates={rates}
                    project={project}
                    currentLanguage={currentLanguage}
                    currentCurrency={currentCurrency}
                    action={{
                      onBeforeAction: this.checkAuth,
                      onSuccess: this.handleModal,
                      onError: this.onError
                    }}
                    isAuthenticated={isAuthenticated}
                    isLikeCompact={isLikeCompact}
                  />
                ) : (
                  <ProjectsListPlaceholderItem />
                )}
              </li>
            )
          })}
        {isAuthenticated && (
          <ModalProjectRemindMe isOpen={this.state.isOpen} onClose={this.handleCloseModal} modalImg={modalImg} />
        )}
        {!isAuthenticated && (
          <ModalProjectNoAuth
            isOpen={this.state.isOpen}
            urls={urls}
            isAuthenticated={isAuthenticated}
            handleClick={this.handleModal}
            onClose={this.handleCloseModal}
            modalImg={modalImg}
          />
        )}
      </ul>
    )
  }
}

ProjectsList.defaultProps = {
  nbPlaceholders: 0,
  noCss: false,
  isLikeCompact: true
}

ProjectsList.propTypes = {
  dataUTMPageContext: dataUTMPageContextShape,
  projects: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentLanguage: PropTypes.string.isRequired,
  currentCurrency: PropTypes.string.isRequired,
  isLikeCompact: PropTypes.bool,
  nbPlaceholders: PropTypes.number,
  // NOTE: The noCss prop is here to ensure this component can be used both with CSS and CSS-in-JS
  // environments, until the component is fully migrated to styled-components.
  noCss: PropTypes.bool
}

export default ProjectsList
